import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    Label,
    Card,
    CardBody
} from 'reactstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
    Colxx,
    Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';

export default function UnifiedInbox({
    saveIntegration,
    channelDetails
}) {
    const [isReceivingEmail, setIsReceivingEmail] = useState(channelDetails !== null ? channelDetails.isReceivingEmail : false);
    const [isReplies, setIsReplies] = useState(channelDetails !== null ? channelDetails.isRepliesEmail : false);
    const handleReceiving = (e) => {
        var details = { ...channelDetails };
        details.isReceivingEmail = e;
        setIsReceivingEmail(e);
        saveIntegration({ channelDetails: details });
    };
    const handleReplies = (e) => {
        var details = { ...channelDetails };
        details.isRepliesEmail = e;
        setIsReplies(e);
        saveIntegration({ channelDetails: details });
    };
    return (<Fragment>
        <Card>
            <CardBody>
                <div className="text-center">
                    <h6>Enable Unified Inbox</h6>
                    {/* <span>Forward email from your normal support email address (such as help@myapp.com) to Unified Inbox so you can view and reply to emails from your inbox.</span> */}
                </div>
                <Separator className="mb-3" />
                <Card className="m-4 p-4">
                    <Colxx className="px-0">
                        <div className="d-flex w-100">
                            <h6>Save to Unified Inbox</h6>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={isReceivingEmail}
                                name='enabled'
                                onChange={(e) => handleReceiving(e)}
                            />
                        </div>
                        <p className="mt-1">Enable Unified Inbox to store email and responses</p>
                    </Colxx>
                    {/* <Colxx className="px-0 mt-3">
                        <div className="d-flex w-100">
                            <h6>Enable Replies (Coming Soon)</h6>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={isReplies}
                                name='enabled'
                                onChange={(e) => handleReplies(e)}
                            />
                        </div>
                        <p className="mt-1">Enable the ability to reply to emails from Unified Inbox</p>
                    </Colxx> */}
                </Card>
            </CardBody>
        </Card>
    </Fragment>)
}  